import copy from './copy.json'
import scoring from './scoring.json'
import metrics from './metrics.json'
import integrations from './integrations.json'
import pricing from './pricing.json'
import demoMetrics from './demo_metrics.json'
import digest from './digest.json'

export type CopyConfig = typeof copy
export type ScoringConfig = typeof scoring
export type MetricsConfig = typeof metrics
export type IntegrationsConfig = typeof integrations
export type PricingConfig = typeof pricing
export type DemoMetricsConfig = typeof demoMetrics
export type DigestConfig = typeof digest

export const copyConfig: CopyConfig = copy
export const scoringConfig: ScoringConfig = scoring
export const metricsConfig: MetricsConfig = metrics
export const integrationsConfig: IntegrationsConfig = integrations
export const pricingConfig: PricingConfig = pricing
export const demoMetricsConfig: DemoMetricsConfig = demoMetrics
export const digestConfig: DigestConfig = digest
